import { render, staticRenderFns } from "./reglas-coincidencia.vue?vue&type=template&id=63052999&scoped=true"
import script from "./reglas-coincidencia.vue?vue&type=script&lang=js"
export * from "./reglas-coincidencia.vue?vue&type=script&lang=js"
import style0 from "./reglas-coincidencia.vue?vue&type=style&index=0&id=63052999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63052999",
  null
  
)

export default component.exports